<template>
  <div class="dash-root">
    <b-container fluid>
      <b-row class="p-0">
        <b-col lg="3" class="p-0">
          <div class="dashside">
            <div class="dashtext p-3">
              <b-button v-b-toggle.sidebar-dash variant="outline-success" class="sbb m-3">
                <b-icon-text-left font-scale="2"></b-icon-text-left>
              </b-button>
              <!-- <b-button v-b-toggle.sidebar-dash class="m-1 sbb" variant="info">
                            <b-icon-list font-scale="2"></b-icon-list>
                        </b-button> -->
              <b-sidebar
                id="sidebar-dash"
                title="Dashboard"
                backdrop-variant="dark"
                bg-variant="white"
                width="350px"
                backdrop
                shadow
              >
                <template #default>
                  <dashboardNavLinks navbody="''"></dashboardNavLinks>
                </template>
              </b-sidebar>
            </div>
            <dashboardNavLinks navbody="navbody" />
          </div>
        </b-col>

        <b-col lg="9">
          <b-row>
            <b-col>
              <b-modal
                id="modal-logout"
                centered
                title="Confirm Exit"
                ok
                ok-variant="success"
                @cancel="hide2nd()"
                cancel-variant="danger"
                @ok="loggingOut()"
              >
                <template v-slot:modal-ok> Yes, Logout </template>
                <p>Are You sure you want to Logout?</p>
              </b-modal>

              <b-modal
                id="modal-download"
                centered
                title="Download our Mobile App"
                ok
                ok-variant="success"
                @cancel="hideDApp()"
                cancel-variant="danger"
                @ok="downloadApp()"
              >
                <template v-slot:modal-ok> Yes, Download </template>
                <p>
                  You are currently running Quicktest on the browser, download our Mobile
                  App for better experience.
                </p>
              </b-modal>

              <b-modal
                id="modal-update"
                centered
                title="Update your App to use Quicktest"
                ok
                ok-variant="success"
                no-close-on-backdrop
                no-close-on-esc
                cancel-disabled
                hide-header-close
                @cancel="hideDApp2()"
                cancel-variant="danger"
                @ok="downloadApp2()"
              >
                <template v-slot:modal-ok> Update Now </template>
                <p>
                  You are using an older version of quicktest that needs to be updated.
                  Please update your app to continue using the Quicktest.
                </p>
              </b-modal>

              <div class="text-right mt-2 profile-tabs">
                <div
                  class="avatar mr-lg-5 mr-1"
                  id="popover-3"
                  @click="shownoti = !shownoti"
                >
                  <!-- <b-button id="popover-3" variant="primary" ref="button"> -->
                  <img
                    class="noti-icon"
                    :class="{ 'noti-icon2': getNotiRead == 0 }"
                    :style="{ left: getNotiRead == 0 ? '-15px' : '' }"
                    src="@/assets/notification.png"
                  /><b-badge v-if="getNotiRead > 0" variant="danger" class="noti-badge">{{
                    getNotiRead
                  }}</b-badge>
                  <!-- </b-button> -->

                  <b-popover
                    :show.sync="shownoti"
                    target="popover-3"
                    triggers="hover focus"
                    placement="bottom"
                  >
                    <template #title>
                      <div class="p-3 text-center">
                        Your Notifications
                        <b-badge v-if="getNotiRead > 0" variant="danger" class="ml-3">{{
                          getNotiRead
                        }}</b-badge>
                      </div>
                    </template>
                    <div class="noti-items-wrapper">
                      <div
                        v-for="(noti, index) in usenotifications"
                        :key="index"
                        style="cursor: pointer"
                        class="border-bottom noti-item rounded"
                        @click="openNoti(noti)"
                      >
                        <div class="p-3">
                          <p :class="{ 'font-weight-bold': getUserRead(index) }">
                            {{ noti.title }}
                          </p>
                          <div
                            :class="{
                              'font-weight-bold': getUserRead(index),
                              'font-weight-lighter': !getUserRead(index),
                            }"
                            class="font-italic"
                          >
                            {{ shortenBody(noti.body) }}
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="notifications.length > 5"
                        @click="$router.push('/dashboard/list-notifications')"
                        class="text-center py-3 view-more-not"
                      >
                        View More
                      </div>
                    </div>
                  </b-popover>

                  <div v-if="false" class="noti-body">
                    <div class="list-noti">
                      <div class="list-noti-body p-1">
                        <span class="noti-subject">New Updates Coming Soon</span>
                        <p class="noti-text">
                          We are happy to announce that the new update for Quicktest is
                          coming up in 2 weeks time...
                        </p>
                      </div>
                      <!-- <div class="list-noti-img img img-rounded p-2">
                                            <img class="img img-rounded noti-img" src="@/assets/competition.jpg" />
                                        </div> -->
                    </div>
                    <div class="list-noti">
                      <div class="list-noti-body p-1">
                        <span class="noti-subject">New Updates Coming Soon</span>
                        <p class="noti-text">
                          We are happy to announce that the new update for Quicktest is
                          coming up in 2 weeks time...
                        </p>
                      </div>
                    </div>
                    <div class="list-noti">
                      <div class="list-noti-body p-1">
                        <span class="noti-subject">New Updates Coming Soon</span>
                        <p class="noti-text">
                          We are happy to announce that the new update for Quicktest is
                          coming up in 2 weeks time...
                        </p>
                      </div>
                    </div>

                    <div class="see-more text-center">
                      <b-button class="mt-1" variant="success">See More</b-button>
                    </div>
                  </div>
                </div>

                <img class="img-dp mt-lg-3" :src="details?.profileimage" />

                <b-dropdown
                  v-if="Object.keys(details).length > 0"
                  class="ml-2 ml-lg-2 mt-lg-3 dropdown-button"
                  right
                  variant="light"
                  :text="
                    details.fname.substring(0, 1) + '' + details.lname.substring(0, 1)
                  "
                >
                  <b-dropdown-item :to="{ name: 'updateprofile' }"
                    >View Profile</b-dropdown-item
                  >
                  <b-dropdown-item @click="confirmLogout()">Log Out</b-dropdown-item>
                </b-dropdown>
              </div>
            </b-col>
          </b-row>
          <router-view class="dash-root"></router-view>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//import NProgress from 'nprogress'
import store from "@/store";
import { mapState, mapActions } from "vuex";
import dashboardNavLinks from "@/components/dashboardNavLinks";
import refreshLogin from "@/mixings/refreshLogin";
import { LocalNotifications } from "@capacitor/local-notifications";
// import { Capacitor } from "@capacitor/core";

export default {
  components: {
    dashboardNavLinks,
  },
  mixings: [refreshLogin],
  created() {
    // if (!this.loggedin) {
    //   this.$router.push({
    //     name: "landing",
    //     query: { redirect: this.$route.fullPath }
    //   });
    // }
  },
  data() {
    return {
      curD: new Date(),
      shownoti: false,
    };
  },
  async mounted() {
    if (this.loggedin) {
      // store.dispatch("dashboard/fetchNotifications");
      // store.dispatch("dashboard/getminiresults");
      // store.dispatch("dashboard/upSchedules");
      // store.dispatch("dashboard/pastSchedules");
      // store.dispatch("dashboard/overallGraph");
      // store.dispatch("dashboard/subjectGraph");
    } else {
      this.$router.push({
        name: "login",
        query: { redirect: this.$route.fullPath },
      });
    }

    this.updateDetails();

    const screenWidth = document.getElementsByTagName("body");

    if (store.state.isNativePlatform == false && screenWidth[0].offsetWidth <= 999) {
      setTimeout(() => {
        this.$bvModal.show("modal-download");
      }, 2000);
    }

    if (store.state.isNativePlatform == true) {
      if (
        parseFloat(store.state.appVersion) < parseFloat(this.details.current_app_version)
      ) {
        setTimeout(() => {
          this.$bvModal.show("modal-update");
        }, 2000);
      }
    }

    this.scheduleNotifications();
    this.setServerNotiToLocalNoti();
  },
  // beforeRouteEnter(to, from, next) {
  //   if (store.state.loggedin) {

  //   }

  //   next();
  // },
  methods: {
    ...mapActions(["logOut"]),
    ...mapActions("loginmaster", ["updateDetails"]),
    ...mapActions("dashboard", ["setNotiReaders"]),

    logout() {
      if (confirm("Are you sure you want to log out? Saved Changes may be lost")) {
        this.logOut().then(() => {
          this.$router.push({
            name: "login",
          });
        });
      }
    },
    confirmLogout() {
      this.$bvModal.show("modal-logout");
    },
    downloadApp() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.quicktestng.app";
    },
    downloadApp2() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.quicktestng.app";

      this.$bvModal.show("modal-update");
    },
    loggingOut() {
      let now = new Date();
      now.setFullYear(now.getFullYear() - 20);
      document.cookie = `remember=;expires=${now.toUTCString()}`;
      document.cookie = `qid=;expires=${now.toUTCString()}`;
      this.logOut().then(() => {
        this.$router.push({
          name: "login",
        });
      });
    },
    hideDApp() {
      this.$bvModal.hide("modal-download");
    },
    hideDApp2() {
      this.$bvModal.hide("modal-update");
    },
    hide2nd() {
      this.$bvModal.hide("modal-logout");
    },
    getUserRead(index) {
      let noti = this.notifications[index];

      return noti.users_read.includes(this.details.trackid) ? false : true;
    },
    shortenBody(body) {
      let formatedBody = body.replace(/(<([^>]+)>)/gi, "");
      let newBody = formatedBody.slice(0, 70) + "...";

      return newBody;
    },
    openNoti(noti) {
      this.shownoti = false;
      this.updateNotiReaders(noti);
      this.$router.push({
        name: "view-notification",
        params: {
          id: noti.id,
        },
      });
    },
    async updateNotiReaders(noti) {
      let payload = {
        user_id: this.details.trackid,
        noti_id: noti.id,
      };

      await this.setNotiReaders(payload).then(() => {
        this.$store.dispatch("dashboard/fetchNotifications");
      });
    },
    scheduleNotifications() {
      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Wake Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Happy Monday! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: 2,
                hour: 8,
                minute: 1,
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 1,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "Have you Practiced Today?",
            body:
              "It is usually said that practice makes perfect, but at Quicktest we believe consistent and personalized practice makes perfect",
            schedule: {
              on: {
                hour: 19,
                minute: 0,
              },
            },
            id: 11,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Wake Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Happy Tuesday! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: "3",
                hour: "8",
                minute: "1",
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 2,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Wake Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Happy Wednesday! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: 4,
                hour: 8,
                minute: 1,
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 3,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Get Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Happy Thursday! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: 5,
                hour: 8,
                minute: 1,
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 4,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Wake Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Happy Weekend! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: 7,
                hour: 8,
                minute: 1,
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 6,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });

      LocalNotifications.schedule({
        notifications: [
          {
            title: "🌟 Wake Up Quicktester! It’s Practice Time! 🌟",
            body:
              "Its Sunny Day! You’re just a step closer to greatness. Take a deep breath, smile, and do what the clock does: keep going. What makes success is your little, repeated efforts. You’ve got this!💪🎶 Click the notification to open the app.",
            schedule: {
              on: {
                weekday: 1,
                hour: 8,
                minute: 1,
              },
              repeats: true,
              allowWhileIdle: true,
            },
            id: 7,
            iconColor: "#243057",
            extra: {
              type: "Motivation Notification",
              redirect: "take_test",
            },
            ongoing: false,
            autoCancel: true,
          },
        ],
      });
    },

    setServerNotiToLocalNoti() {
      this.getNotiUnRead.forEach((x) => {
        // console.log(x);
        LocalNotifications.schedule({
          notifications: [
            {
              title: x.title,
              body: this.shortenBody(x.body) + "...Read More",
              id: 100,
              iconColor: "#243057",
              extra: {
                type: "Motivation Notification",
                redirect: "take_test",
              },
              ongoing: false,
              autoCancel: true,
            },
          ],
        });
      });
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      start_config: (state) => state.exam.start_config,
      plan: (state) => state.loginmaster.details.plan,
      trial: (state) => state.loginmaster.trial,
      premium: (state) => state.loginmaster.details.premium_details,
      started: (state) => state.exam.started,
      allinsti: (state) => state.exam.allinstitutions,
      isNativePlatform: (state) => state.isNativePlatform,
      notifications: (state) => state.dashboard.notifications,
    }),
    getNotiRead() {
      let noti = this.notifications.map((x) => x.users_read);
      let unread =
        this.notifications.length -
        noti.filter((x) => x.includes(this.details.trackid)).length;
      return unread;
    },
    getNotiUnRead() {
      // let noti = this.notifications.map((x) => x.users_read);
      let unread = this.notifications.filter((x) => {
        if (!x.users_read.includes(this.details.trackid)) {
          return x;
        }
      });
      return unread;
    },
    usenotifications() {
      return this.notifications.slice(0, 5);
    },
  },
};
</script>

<style scoped>
.dashside {
  background-color: white;
  margin-top: -18px;
  height: 100%;
}

.dashtext {
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  color: gray;
}
.dash-root {
  background-color: #fbfbfb;
}
.avatar {
  width: 55px;
  height: 45px;
  border-radius: 15px 15px;
  background-color: white;
  display: inline-block;
  cursor: pointer;
}

.img-dp {
  width: 55px;
  height: 55px;
  display: inline-block;
  border-radius: 5px 5px;
}
.noti-icon {
  position: relative;
  left: -15px;
  top: 10px;
  cursor: pointer;
}
.dropdown-button {
  background-color: white;
}
.sbb {
  border: 0px;
  z-index: 9999px;
}
.noti-badge {
  position: relative;
  left: -25px;
}

.noti-body {
  position: absolute;
  z-index: 999;
  top: 80px;
  right: 10px;
  min-height: 30vh;
  width: 400px;
  border-radius: 10px 10px;
}

.list-noti {
  border-bottom: 1px solid rgb(58, 55, 55);
  background-color: rgb(245, 245, 249);
  width: full-width;
  display: flex;
}

.list-noti-body {
  text-align: left;
}

.noti-item {
  cursor: pointer;
  margin: -10px;
}

.noti-item:hover {
  background-color: rgb(246, 242, 242);
}

.noti-items-wrapper {
  max-height: 700px;
}
.noti-img {
  width: 60px;
  height: 60px;
  border-radius: 100px 100px;
}
.noti-subject {
  font-weight: bold;
}
.noti-text {
  font-size: 0.8rem;
}

.noti-pop {
  width: 400px;
}

.view-more-not {
  margin: -10px;
}
.view-more-not:hover {
  background-color: rgb(246, 242, 242);
  cursor: pointer;
}

@media screen and (max-width: 999px) {
  .profile-tabs {
    display: flex;
    position: absolute;
    right: 5%;
    top: -100px;
  }
  .noti-body {
    top: 50px;
    right: -10px;
    width: 300px;
  }
}
@media screen and (min-width: 768px) {
  .sbb {
    display: none;
  }
  .dash-root {
  }
  .noti-icon {
    position: relative;
    left: -5px;
    top: 10px;
  }
  .noti-icon2 {
    left: -15px;
  }
  .noti-badge {
    position: relative;
    left: -15px;
  }
}
</style>
